import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft, Package } from "lucide-react";
import MasterResourceInfo from "./MasterResourceInfo";
import "./ViewMasterResource.css";

const ViewMasterResource = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const resourceData = location.state?.data;

  return (
    <div style={{ margin: "8px", fontFamily: "'Poppins', 'Segoe UI', sans-serif" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700;800&display=swap');`}</style>
      <div className="mrv-header-banner">
        <button type="button" className="mrv-back-btn" onClick={() => navigate(-1)} aria-label="Back">
          <ArrowLeft size={16} />
        </button>
        <span className="mrv-header-icon">
          <Package size={14} color="#fff" />
        </span>
        <div>
          <div className="mrv-header-title">View Master Resource</div>
          <div className="mrv-header-subtitle">Master resource inventory details</div>
        </div>
      </div>
      <MasterResourceInfo resourceData={resourceData} />
    </div>
  );
};

export default ViewMasterResource;
